module.exports = __webpack_public_path__ + "fontoctopus.eaba275a17557acd1c701e4f1fe4e7be.hashedasset.svg";